import type { ValidationRequestLog } from '@percent/admin-dashboard/api/types'

export const mockValidationRequestLogsResponse: { data: ValidationRequestLog[] } = {
  data: [
    {
      id: 'staging_vrlog_XXXXXXXXXXXXXXXXXL',
      type: 'validation_request_rejected',
      createdAt: '2024-04-29T07:48:42.673Z',
      data: {
        account: 'staging_account_XXXXXXXXXXXXXXXXXA',
        accountEmail: 'ops.agent@goodstack.io',
        rejectionReasonCode: 'incorrect_documentation'
      }
    },
    {
      id: 'staging_vrlog_XXXXXXXXXXXXXXXXXK',
      type: 'document_received',
      createdAt: '2024-04-29T07:48:42.578Z',
      data: {}
    },
    {
      id: 'staging_vrlog_XXXXXXXXXXXXXXXXXJ',
      type: 'document_requested',
      createdAt: '2024-04-29T07:48:42.377Z',
      data: {
        account: 'staging_account_XXXXXXXXXXXXXXXXXA',
        accountEmail: 'ops.agent@goodstack.io'
      }
    }
  ]
}
